import { createContext } from "react";
const RowSelectionContext = /*#__PURE__*/createContext();
export default RowSelectionContext;